// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__n6g6Q","option":"styles_option__tTexH","active":"styles_active__2voWp"};